import React from 'react';

const TableSortDownIcon = () => (
    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.375 10.5087L4.375 0L2.625 0L2.625 10.5087H0L3.5 14L7 10.5087L4.375 10.5087Z"
            fill="#EBB02D"
        />
    </svg>
);

export { TableSortDownIcon };
